import React from 'react';
import api from '../../../../../../services/api';
import { useToast } from '../../../../../../hooks/Toast';
import * as Yup from 'yup';
import { useAuth } from '../../../../../../hooks/Auth';
import { FiCopy, FiSend } from 'react-icons/fi';
import Whatsapp from '../../../../../../components/Whatsapp';
import { authTitle } from '../../../../../../config';
import { FaMoneyBill, FaMoneyBillAlt, FaPlusCircle } from 'react-icons/fa';
import { useParams } from 'react-router-dom';
import downloadit from '../../../../../../utils/download';
import { string } from 'yup';
import { useSearch } from '../../../../../../hooks/Search';
import { useModal } from '../../../../../../hooks/Modal';
import { useConfiguration } from '../../../../../../hooks/Configuration';
import { uuid } from 'uuidv4';
import FormComponent, { sanitizeDataObject } from '../../../../core/components/FormComponent';
import { createSchemaByForm } from '../../../../../../utils/SchemaCreator';
import { FormHandles } from '@unform/core';
import getValidationErrors from '../../../../../../utils/getValidationErrors';
import { useLoading } from '../../../../../../hooks/LoadingHook';

interface ICreateModule {
  lineData?: Record<string, any>;
}

export const DuplicateNewProjectModule: React.FC<ICreateModule> = ({ lineData }) => {


  const { addToast } = useToast();
  const { reloadSearchAll } = useSearch();
  const { addModal, removeModal } = useModal();
  const { addLoading, removeLoading } = useLoading();
  const { projectHash, eventHash } = useConfiguration()
  const key = uuid();
  const formSchema = {
    reference_number: { model: 'input', type: 'text', name: 'reference_number', label: 'Código SAGI / SIAF', defaultValue: lineData?.reference_number },
    title: { model: 'input', type: 'text', name: 'title', label: 'Nome do Projeto', defaultValue: lineData?.title },
    start_date: { model: 'datePicker', type: 'text', name: 'start_date', label: 'Data de Referência' },
    date_text: { model: 'input', type: 'text', name: 'date_text', label: 'Data em Texto (Ex: 02 a 4 de abril de 2024)' },
    event_type: {
      defaultValue: 'Presencial',
      model: 'selectSimple', type: 'text', name: 'event_type', label: 'Tipo de evento', options: [
        { label: 'Online', value: 'Online' },
        { label: 'Híbrido', value: 'Híbrido' },
        { label: 'Presencial', value: 'Presencial' },
      ]
    },

    cnpj: { model: 'maskedInput', mask: "99.999.999/9999-99", type: 'text', name: 'cnpj', label: 'CNPJ', defaultValue: '94.391.901/0001-03' },
    bank: {
      model: 'selectSimple', type: 'text', name: 'bank', label: 'Banco', options: [
        { label: 'Banco do Brasil', text: 'Banco do Brasil', value: '001' },
        { label: 'Sicredi', text: 'Sicredi', value: '748' },
      ]
    },



    bank_agency: { model: 'input', type: 'text', name: 'bank_agency', pattern: 'agency', label: 'Agência' },
    bank_agency_dv: { model: 'input', type: 'text', name: 'bank_agency_dv', pattern: 'dv', label: 'Ag. DV' },
    bank_account: { model: 'input', type: 'text', name: 'bank_account', pattern: 'number', label: 'Conta corrente' },
    bank_account_dv: { model: 'input', type: 'text', name: 'bank_account_dv', pattern: 'dv', label: 'Conta Corrent DV' },


  }

  const formValidation: Record<string, any> = {
    title: {
      name: 'title',
      type: 'string',
      label: 'Nome do Evento',
      rules: [{ type: 'required' }],
    },

    cnpj: {
      name: 'cnpj',
      type: 'string',
      label: 'CNPJ',
      rules: [{ type: 'required' }],
    },
    bank: {
      name: 'bank',
      type: 'string',
      label: 'Banco',
      rules: [{ type: 'required' }],
    },
    bank_agency: {
      name: 'bank_agency',
      type: 'string',
      label: 'Agência',
      rules: [{ type: 'required' }],
    },
    bank_agency_dv: {
      name: 'bank_agency_dv',
      type: 'string',
      label: 'Agência DV',
      rules: [{ type: 'required' }],
    },
    bank_account: {
      name: 'bank_account',
      type: 'string',
      label: 'C/C',
      rules: [{ type: 'required' }],
    },
    bank_account_dv: {
      name: 'bank_account_dv',
      type: 'string',
      label: 'C/C DV',
      rules: [{ type: 'required' }],
    },

  };

  const setCallback = async (
    data: Record<string, any>,
    formRef: React.RefObject<FormHandles>,
  ): Promise<void> => {
    try {
      const newData = sanitizeDataObject(data, formSchema);

      const schema = createSchemaByForm(formValidation);
      await schema.validate(newData, { abortEarly: false });

      if (projectHash) {
        newData.project_id = projectHash;
      }
      if (eventHash) {
        newData.event_id = eventHash;
      }
      addLoading({ title: 'Carregando', key: 'loading' })

      newData.payment_hash = 're_clx4o8ucu4i59019tm6m48shr';
      newData.new_finance = 'yes';
      const response = await api.post(`duplicate-new-project/${lineData?.url}`, newData);

      if (response.status !== 200) {
        removeLoading('loading');
        return addToast({ type: 'error', title: 'Erro ao salvar' });
      }

      removeModal(key);

      addToast({ type: 'success', title: 'Salvo com sucesso' });
      await reloadSearchAll();
      removeLoading('loading');
    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        const errors = getValidationErrors(err);
        removeLoading('loading');
        formRef.current?.setErrors(errors);
        return;
      }
      removeLoading('loading');
      return addToast({ type: 'error', title: err.response.data.error });
    }
  };




  const handleCreate = (): void => {
    const content = (
      <FormComponent schema={formSchema} setCallback={setCallback} />
    );
    if (content) {
      const keyModal = addModal({ title: 'Novo Projeto - Duplicação', content, key, theme: "whiteModal" });
    }
  };




  const moduleUpdate = (): JSX.Element => (
    <><button title="Duplicar Projeto" className="searchButton" type="button" onClick={() => handleCreate()}>
      <FiCopy />
    </button>
    </>
  );

  return moduleUpdate();
}
